// extracted by mini-css-extract-plugin
export var container = "bib-calendar-no-animation-module--container--99407";
export var containerButton = "bib-calendar-no-animation-module--containerButton--84ccf";
export var containerSkeletonLoader = "bib-calendar-no-animation-module--containerSkeletonLoader--73e73";
export var diverror = "bib-calendar-no-animation-module--diverror--e9be1";
export var loading = "bib-calendar-no-animation-module--loading--8628e";
export var perror = "bib-calendar-no-animation-module--perror--82680";
export var perrorTwo = "bib-calendar-no-animation-module--perrorTwo--c2616";
export var root = "bib-calendar-no-animation-module--root--0c963";
export var skeletonCell = "bib-calendar-no-animation-module--skeletonCell--e1aaf";
export var skeletonHeader = "bib-calendar-no-animation-module--skeletonHeader--bade5";
export var skeletonLoader = "bib-calendar-no-animation-module--skeletonLoader--fe805";
export var tableContainer = "bib-calendar-no-animation-module--tableContainer--81167";